module.exports = __webpack_public_path__ + "img/CM-MS-24-Buick-Established.9b260978.jpg";